import {
  GroupedAccounts,
  TransferNotPossibleError,
  TransferOptions,
} from '@varo/graphql-schema-types';
import DestinationAccountsQuery from 'services/graphql/queries/MoveMoney/DestinationAccountsQuery';
import EstimateTransferOptionsQuery from 'services/graphql/queries/MoveMoney/EstimateTransferOptionsQuery';
import SourceAccountsQuery from 'services/graphql/queries/MoveMoney/SourceAccountsQuery';
import { useQuery } from 'urql';

interface TransferInput {
  amount: number;
  currency: string;
  destinationAccountId: string;
  sourceAccountId: string;
}

export const useTransferMoney = (transferInput: TransferInput | null) => {
  const [
    { data: sourceData, error: sourceError, fetching: sourceFetching },
    refreshSourceAccounts,
  ] = useQuery<{
    transferOptions: TransferOptions;
  }>({
    query: SourceAccountsQuery,
    requestPolicy: 'cache-and-network',
  });

  const [
    {
      data: destinationData,
      error: destinationError,
      fetching: destinationFetching,
    },
    refreshDestinationAccounts,
  ] = useQuery<{
    transferOptions: TransferOptions;
  }>({
    query: DestinationAccountsQuery,
    variables: { input: { ...transferInput, destinationAccountId: '' } },
    requestPolicy: 'network-only',
    pause: !(
      transferInput?.sourceAccountId !== '' &&
      transferInput?.destinationAccountId === ''
    ),
  });

  const [{ data: transferEstimateData }] = useQuery<{
    transferOptions: TransferOptions;
  }>({
    query: EstimateTransferOptionsQuery,
    variables: { input: transferInput },
    requestPolicy: 'cache-and-network',
    pause: !(
      transferInput?.sourceAccountId !== '' &&
      transferInput?.destinationAccountId !== ''
    ),
  });

  return {
    sourceData: sourceData?.transferOptions?.source as GroupedAccounts,
    destinationData: destinationData?.transferOptions
      ?.destination as GroupedAccounts,
    transferEstimateData: transferEstimateData?.transferOptions,
    error: sourceError ? sourceError : destinationError,
    fetching: sourceFetching ? sourceFetching : destinationFetching,
    refreshSourceAccounts: refreshSourceAccounts,
    refreshDestinationAccounts: refreshDestinationAccounts,
    transferPossibleError:
      sourceData?.transferOptions as unknown as TransferNotPossibleError,
  };
};
